export { PIN_ERROR_CODES as AUTH_STEP_UP_CODES } from "../../../services/utils/pinAuthUtils";

export const AUTH_ACTION_TYPES = {
  AUTH_STEP_UP: "AUTH_STEP_UP",
  AUTH_STEP_UP_ENROLL: "AUTH_STEP_UP_ENROLL",
};

export const PIN_VALIDATION_CODES = {
  INVALID_FORMAT: "PIN_INVALID_FORMAT",
  SEQUENTIAL_NOT_ALLOWED: "PIN_SEQUENTIAL_NOT_ALLOWED",
  REPEATED_NOT_ALLOWED: "PIN_REPEATED_NOT_ALLOWED",
  CONFIRM_MISMATCH: "PIN_CONFIRM_MISMATCH",
};

export const PIN_ENROLL_CODES = {
  CHALLENGE_ALREADY_USED: "PIN_CHALLENGE_ALREADY_USED",
  ALREADY_SET: "PIN_ALREADY_SET",
};

export const PIN_SETUP_CODES = {
  SUCCESS: "PIN_SETUP_SUCCESS",
};

export const PIN_CHANGE_CODES = {
  SUCCESS: "PIN_CHANGE_SUCCESS",
  CURRENT_INVALID: "PIN_CURRENT_INVALID",
  NEW_MUST_DIFFER: "PIN_NEW_MUST_DIFFERENT",
};

const DEAD_TOKEN_KEYWORDS = [
  "expired",
  "already used",
  "already been used",
  "invalid",
];

export const isDeadTokenMessage = (message) => {
  if (!message) return false;
  const lower = message.toLowerCase();
  return (
    lower.includes("token") &&
    DEAD_TOKEN_KEYWORDS.some((keyword) => lower.includes(keyword))
  );
};

export const PIN_CHANGE_ERROR_MESSAGES = {
  [PIN_CHANGE_CODES.CURRENT_INVALID]: {
    field: "currentPin",
    message: "Current PIN is incorrect.",
  },
  [PIN_CHANGE_CODES.NEW_MUST_DIFFER]: {
    field: "newPin",
    message: "New PIN must be different from your current PIN.",
  },
  [PIN_VALIDATION_CODES.INVALID_FORMAT]: {
    field: "newPin",
    message: "PIN must be exactly 6 digits.",
  },
  [PIN_VALIDATION_CODES.CONFIRM_MISMATCH]: {
    field: "confirmPin",
    message: "PINs do not match.",
  },
  [PIN_VALIDATION_CODES.SEQUENTIAL_NOT_ALLOWED]: {
    field: "newPin",
    message: "Sequential PINs are not allowed.",
  },
  [PIN_VALIDATION_CODES.REPEATED_NOT_ALLOWED]: {
    field: "newPin",
    message: "Repeated-digit PINs are not allowed.",
  },
};
